import React from 'react';

const LineLoader = ({active}) => {
    return (
        active ? <div className='line-loader'/> : null
    );
};

export default LineLoader;


// WEBPACK FOOTER //
// ./App/components/Loader/LineLoader.jsx